import * as types from "../../../databse/types";
/*Modal Shopping Card*/
export const handelOpenModalShoppingCard = () => ({
    type: 'OPEN_MODAL_SHOPPING_CARD'
});
export const handelCloseModalShoppingCard = () => ({
    type: 'CLOSE_MODAL_SHOPPING_CARD'
});
export const handelToggleAnimationModalShoppingCard = (statusAnimation) => ({
    type: 'TOGGLE_ANIMATION_MODAL_SHOPPING_CARD',statusAnimation
});
export const handelArrowModalShoppingCard = (statusPrevAndNext) => ({
    type: 'TOGGLE_ARROW_MODAL_SHOPPING_CARD',statusPrevAndNext
});
export const handelChangeLevelPaymentModalShoppingCard = (levelPayment,titleModalShoppingCard) => ({
    type: 'CHANGE_LEVEL_PAYMENT_SHOPPING_CARD',levelPayment,titleModalShoppingCard
});

/*Card*/
export const actionAddItemInSHoppingCard = (product,selectGrade,numbers,optionSelect=null) => ({
    type: 'ADD_ITEM_IN_SHOPPING_CART',product,selectGrade,numbers,optionSelect
});

export const actionSetApiCardsModalShoppingCard = (apiCarts) => ({
    type: 'CHANGE_API_CARTS_LIST_PRODUCTS_MODAL_SHOPPING_CARD',apiCarts
});
export const actionHandelRemoveAllItemInBasketCart = () => ({
    type: 'REMOVE_ALL_ITEM_IN_BASKET_CART',
});
export const actionRemoveItemInBasketCart = (gradeId) => ({
    type: 'REMOVE_ITEM_IN_BASKET_CART', gradeId,
});

export const actionRefreshModalShoppingCard = () => ({
    type: types.REFRESH_MODAL_SHOPPING_CARD,
});
export const actionChangeInputsModalShoppingCard = (name,value) => ({
    type: types.CHANGE_INPUTS_MODAL_SHOPPING_CARD,name,value
});

/*Loader*/
export const actionLoaderProductsModalShoppingCard = (loaderListProducts) => ({
    type: 'CHANGE_LOADER_LIST_PRODUCTS_MODAL_SHOPPING_CARD',loaderListProducts
});

/*Part Times*/
export const actionGatDaysInAPiFOrModalShoppingCart = (days) =>({
    type:types.CHANGE_DAYS_SELECT_MODAL_SHOPPING_CARD,days
});
export const actionChangeActiveDayPostSchedule = (activeDayPostSchedule) =>({
    type:types.CHANGE_ACTIVE_DAY_POST_SCHEDULE,activeDayPostSchedule
});
export const actionChangeActiveSelectTablePostSchedule = (activeSelectTablePostSchedule) =>({
    type:types.CHANGE_ACTIVE_SELECT_TABLE_POST_SCHEDULE,activeSelectTablePostSchedule
});
export const actionChangeListQuestions = (questions) =>({
    type:types.CHANGE_LIST_QUESTIONS,questions
});

//Question
export const actionChangeSelectableQuestion = (selectableQuestion) =>({
    type:types.CHANGE_SELECTABLE_ITEM_QUESTION_MODAL_SHOPPING_CARD,selectableQuestion
/*Invoice*/
});
export const actionChangeInvoiceModalShoppingCard = (invoice) =>({
    type:types.HANDEL_CHANGE_INVOICE_MODAL_SHOPPING_CARD,invoice
});
export const actionAddItemInInvoice = (item) =>({
    type:types.ADD_ITEM_IN_INVOICE,item
});
export const actionRemoveItemInInvoice = (item,count) =>({
    type:types.REMOVE_ITEM_IN_INVOICE,item,count
});
export const actionChangeLoaderInvoiceModalShoppingCard = (statusLoaderPrice) =>({
    type:types.HANDEL_CHANGE_LOADER_PRICE_INVOICE,statusLoaderPrice
});
export const actionChangePayTypeClickInvoice = (payTypeClick) =>({
    type:types.CHANGE_PAY_TYPE_CLICK_INVOICE,payTypeClick
});

